import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { FaArrowUp } from 'react-icons/fa6';

export const timeOfDayLabelBySegment = Object.freeze({
  M: 'Morning',
  A: 'Afternoon',
  E: 'Evening',
  N: 'Night',
});

export const timeOfDayOrder = Object.freeze(['Morning', 'Afternoon', 'Evening', 'Night']);

export const timeOfDayDetails = [
  {
    id: 'precipitationProbability',
    label: 'Precipitation probability',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRECIPITATION_PROBABILITY,
    getValue: (forecast) => `${forecast?.precip_prob ?? '--'}%`,
  },
  {
    id: 'windSpeedAndDirection',
    label: 'Wind',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (forecast) => {
      const windDirection = forecast?.wind_dir;

      return (
        <div className="d-flex align-items-center gap-1">
          <span>
            {`${forecast?.wind_speed ?? '--'} MPH / ${forecast?.wind_short ?? '--'} (${windDirection ?? '--'}°)`}
          </span>
          {windDirection != null && (
            <FaArrowUp
              className="flex-shrink-0 detailed-forecast-wind-arrow"
              aria-hidden="true"
              focusable="false"
              size={16}
              style={{ transform: `rotate(${windDirection}deg)` }}
            />
          )}
        </div>
      );
    },
  },
];
